import moment from 'moment'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useParams } from 'react-router'
import { setFavorite, unsetFavorite } from '../../../../../redux/actions/favorites'
import { showOffer, toggleFormOffer } from '../../../../../redux/actions/offers'
import { IRootState } from '../../../../../redux/types'
import { MoreInfoDetail } from '../../../../backoffice/library/models/resource'
import useUserDisplaytime from '../../../../shared/hooks/useUserDisplaytime'

export const useOfferDetail = () => {
  const { t } = useTranslation(['global'])
  const { id } = useParams<{ id: string }>()
  const dispatch = useDispatch()
  const location = useLocation()

  const { isAuth, user: authUser } = useSelector((state: IRootState) => state.auth)
  const { offer_selected, showForm } = useSelector((state: IRootState) => state.offer)

  const [favoriteState, setFavoriteState] = useState<boolean>(false)

  useUserDisplaytime({ foreign: offer_selected })

  useEffect(() => {
    dispatch(showOffer(id))
  }, [id, dispatch])

  useEffect(() => {
    if (offer_selected !== null) {
      setFavoriteState(Boolean(offer_selected.favoriteId))
    }
  }, [offer_selected])

  const getInfoDetail = (): MoreInfoDetail => {
    if (!offer_selected) return { item: [] }

    return {
      item: [
        {
          id: 0,
          type: 'tag',
          title: 'Tags',
          color: 'light',
          info: `${offer_selected?.tags
            ?.map((tag: any) => {
              return tag.name.toUpperCase()
            })
            .join(', ')}`
        },
        {
          id: 1,
          type: 'date',
          title: `${t('start-date')}`,
          color: 'grey6',
          info: `${moment(offer_selected?.created_at).format('LL')}`
        }
      ]
    }
  }

  const handleFavoriteClick = (offer_id: number) => (state: boolean) => {
    if (state) {
      dispatch(
        setFavorite({
          id: offer_id,
          type: 'offer'
        })
      )
    } else {
      dispatch(
        unsetFavorite({
          id: offer_id,
          type: 'offer'
        })
      )
    }
    setFavoriteState(state)
  }

  const handleGoBack = () => {
    window.location.pathname = '/ofertas'
  }

  const handleDownloadMedia = (fileName: string) => {
    window.open(`${import.meta.env.VITE_API_URL}/offers/download/${fileName}`)
  }

  const handleToggleForm = () => {
    dispatch(toggleFormOffer())
  }

  return {
    offer_selected,
    showForm,
    isAuth,
    authUser,
    favoriteState,
    location,
    infoDetail: getInfoDetail(),
    handleFavoriteClick,
    handleGoBack,
    handleDownloadMedia,
    handleToggleForm
  }
}
